import { ValidationResult } from '@/policy/types/ValidationResult';

interface UseValidationHandlersProps {
  validation: ValidationResult;
  onValidationChange: (validation: ValidationResult) => void;
}

export const useValidationHandlers = ({
  validation,
  onValidationChange,
}: UseValidationHandlersProps) => {
  const handleCoherentClick = () => {
    onValidationChange({ status: 'COHERENT' });
  };

  const handleErrorClick = () => {
    onValidationChange({
      status: 'ERROR',
      description: '',
      confirmed: false,
    });
  };

  const handleDescriptionChange = (description: string) => {
    if (validation.status === 'ERROR') {
      onValidationChange({ status: 'ERROR', description, confirmed: false });
    }
  };

  const handleCancel = () => {
    if (validation.status === 'ERROR' && validation.confirmed) {
      return;
    }
    onValidationChange({ status: 'NONE' });
  };

  const handleSave = () => {
    if (validation.status === 'ERROR') {
      onValidationChange({
        status: 'ERROR',
        description: validation.description,
        confirmed: true,
      });
    }
  };

  return {
    handleCoherentClick,
    handleErrorClick,
    handleDescriptionChange,
    handleCancel,
    handleSave,
  };
};
